import posthog from "posthog-js";

const PH_KEY = import.meta.env.VITE_POSTHOG_KEY || "phc_rnPQMVrYsf9qvWFn6Se6S47hBMtvqHVTZA4u8qfeAKuz";
const PH_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com";

let isInitialized = false;

export function initPostHog() {
  if (!PH_KEY) {
    console.warn("[PostHog] VITE_POSTHOG_KEY not set — analytics disabled.");
    return;
  }
  posthog.init(PH_KEY, {
    api_host: PH_HOST || "https://eu.i.posthog.com",
    capture_pageview: false,
    capture_pageleave: true,
    persistence: "localStorage+cookie",
  });
  isInitialized = true;
}

/** Typed capture helper — keeps event names consistent across the codebase. */
export function phCapture(
  event: PhEvent,
  properties?: Record<string, unknown>,
) {
  if (!isInitialized) return;
  posthog.capture(event, properties);
}

/** Safe identify — no-ops when PostHog is not initialised. */
export function phIdentify(userId: string) {
  if (!isInitialized) return;
  posthog.identify(userId);
}

/** Safe reset — no-ops when PostHog is not initialised. */
export function phReset() {
  if (!isInitialized) return;
  posthog.reset();
}

export type PhEvent =
  | "landing_viewed"
  | "landing_page_viewed"
  | "generate_page_viewed"
  | "onboarding_started"
  | "onboarding_preview_viewed"
  | "onboarding_signup_clicked"
  | "onboarding_skipped"
  | "onboarding_completed"
  | "sign_in_started"
  | "sign_in_succeeded"
  | "report_generation_started"
  | "report_generation_succeeded"
  | "report_generation_failed"
  | "report_viewed"
  | "upgrade_clicked"
  | "checkout_started"
  | "checkout_succeeded";

// TODO: Wire checkout_started / checkout_succeeded when Stripe is integrated.
// Example usage:
//   phCapture("checkout_started", { plan: "pro", source: "pricing" });
//   phCapture("checkout_succeeded", { plan: "pro" });

export { posthog };
